var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25163 6.90476H18.7484L12.6734 12.9797C12.3015 13.3516 11.6985 13.3516 11.3266 12.9797L5.25163 6.90476ZM7.79599 12.1429L3.90476 8.25163L3.90476 16.0341L7.79599 12.1429ZM18.7484 17.381H5.25163L9.14286 13.4897L9.97969 14.3266C11.0955 15.4423 12.9045 15.4423 14.0203 14.3266L14.8571 13.4897L18.7484 17.381ZM20.0952 16.0341V8.25163L16.204 12.1429L20.0952 16.0341ZM2 6.90476C2 5.85279 2.85279 5 3.90476 5H20.0952C21.1472 5 22 5.85279 22 6.90476V17.381C22 18.4329 21.1472 19.2857 20.0952 19.2857H3.90476C2.85279 19.2857 2 18.4329 2 17.381V6.90476Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailing);
export default __webpack_public_path__ + "static/media/mailing.ab27e995.svg";
export { ForwardRef as ReactComponent };